import React, { useContext } from "react";
import style from "./index.module.scss";
import { GroupAnswerViewItem } from "../../../../../service/group";
import ListItem from "./Components/ListItem";
import { Col, Row } from "antd";
import { useHistory } from "react-router-dom";
import { courseProjectionUrl } from "../../../../../service/url";
import { CourseContext } from "../../../Store";

interface GroupListProps {
    selectedIndex: number;
    list: GroupAnswerViewItem[];
    onChangeSelect: (val: GroupAnswerViewItem) => void;
    setShowList: (showList: boolean) => void;
}

const GroupList = ({
    selectedIndex,
    list,
    onChangeSelect,
    setShowList
}: GroupListProps) => {
    const history = useHistory();
    const { course } = useContext(CourseContext);
    const onSelect = (item: GroupAnswerViewItem, index: number) => {
        onChangeSelect(item);
        setShowList(false);
        history.replace(
            courseProjectionUrl(
                course.weekTimeId,
                `group/${item.activityId}/${item.homeworkId}`
            )
        );
    };
    return (
        <div className={style.root}>
            <div className={style.list}>
                <div style={{ overflow: "hidden" }}>
                    <Row type="flex" gutter={[20, 20]}>
                        {list.map((item, index) => (
                            <Col span={8} key={item.homeworkId}>
                                <ListItem
                                    current={index === selectedIndex}
                                    item={item}
                                    onSelect={() => onSelect(item, index)}
                                />
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default GroupList;
